<template>
  <div>
    <div class="card-sakali pt-1 mb-0" v-if="teamInfos">
      <div class="row mt-1">
        <div class="col text-center text-truncate text-nowrap p-1"
             v-for="ti in teamInfos"
             :key="ti.id">
          <div class="d-block">
            <team-emblem size="50" :emblem-id="match.team1.emblemId" v-if="ti === teamInfos[0]"/>
            <team-emblem size="50" :emblem-id="match.team2.emblemId" v-if="ti === teamInfos[1]"/>
          </div>
          <div class="d-block">
            <span>{{ ti.name }}</span>
          </div>
          <div class="d-block text-center justify-content-center">
            <span class="text-nowrap" v-if="!ti.coach.cpu">
              <cld-image
                  :public-id="'/sandkastenliga/avatars/' + ti.coach.avatarId"
                  width="25"
                  dpr="3.0"
                  crop="fill">
                <cld-transformation radius="max"/>
              </cld-image>
              {{ ti.coach.name }}
            </span>
            <span v-else class="text-muted">trainerlos</span>
          </div>
        </div>
      </div>
      <table class="text-center small condensed w-75 mx-auto overflow-hidden">
        <tr>
          <td>{{ teamInfos[0].kies | kies }}</td>
          <td>Kies</td>
          <td>{{ teamInfos[1].kies | kies }}</td>
        </tr>
        <tr v-if="scores">
          <td>{{ score(true).rank }}.</td>
          <td>Platz</td>
          <td> {{ score(false).rank }}.</td>
        </tr>
        <tr>
          <td>
            <div class="progress border border-white bg-transparent">
              <div class="progress-bar bg-secondary ms-auto" role="progressbar"
                   :style="{'width':teamInfos[0].strength + '%'}">
                {{ teamInfos[0].strength | float }}
              </div>
            </div>
          </td>
          <td class="px-1">Stärke</td>
          <td>
            <div class="progress border border-white bg-transparent">
              <div class="progress-bar bg-secondary" role="progressbar"
                   :style="{'width':teamInfos[1].strength + '%'}">
                {{ teamInfos[1].strength | float }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <last-games-widget :last-games="teamInfos[0].lastGameResults"></last-games-widget>
          </td>
          <td>Ergebnisse</td>
          <td>
            <last-games-widget :last-games="teamInfos[1].lastGameResults"></last-games-widget>
          </td>
        </tr>
        <tr>
          <td>
            <last-motivations-widget
                :motivation-list="teamInfos[0].lastGameMotivations"></last-motivations-widget>
          </td>
          <td>Motivation</td>
          <td>
            <last-motivations-widget
                :motivation-list="teamInfos[1].lastGameMotivations"></last-motivations-widget>
          </td>
        </tr>
      </table>
    </div>
    <div class="mt-0 d-flex d-md-none justify-content-center">
      <div @click="toggleView" class="mt-0 px-2 bg-white small text-dark">Liste aller Spiele</div>
    </div>
  </div>

</template>

<script>
import lastGamesWidget from './LastGamesWidget'
import lastMotivationsWidget from './LastMotivationsWidget'

export default {
  props: {
    match: Object,
    scores: Array
  },
  data() {
    return {
      teamInfos: null
    }
  },
  methods: {
    score(home) {
      let res = null
      if (this.match && this.scores) {
        const teamId = (home ? this.match.team1.id : this.match.team2.id)
        this.scores.forEach(s => {
          if (s.team.id == teamId)
            res = s
        })
        return res
      }
    },
    toggleView() {
      this.$emit('toggle-view');
    },
    loadTeamInfos() {
      this.$api.get('/teaminfos/' + this.match.team1.id).then(result => {
        const t1 = result.data
        this.$api.get('/teaminfos/' + this.match.team2.id).then(result => {
          this.teamInfos = [t1, result.data]
        })
      })
    },
  },
  watch: {
    match() {
      this.loadTeamInfos()
    }
  },
  created() {
    this.loadTeamInfos()
  },
  components: {
    lastMotivationsWidget,
    lastGamesWidget
  }
}
</script>

<style>
.condensed td {
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}
</style>
